module.exports = __webpack_public_path__ + "img/RS1619xs+.9e891934.png";